var render = function render(){var _vm=this,_c=_vm._self._c;return _c('omk-icon-button',{staticClass:"delete-icon-btn",attrs:{"button-type":"outlined-icon-button"},on:{"click":function($event){return _vm.$emit('click')}}},[_c('omk-icon',{attrs:{"outline-variant":""}},[_vm._v("delete")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }